import React, { useContext, useEffect, useState } from 'react'
import Header from '../../Header/Header'
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import logo from '../../../assets/logo.png';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClock, faHeart, faLocationDot, faMoneyBillWave } from "@fortawesome/free-solid-svg-icons";
import './EventCard.css'
import UserContext from '../../../UserContext';
import { faCalendarDays} from "@fortawesome/free-solid-svg-icons";
import { ToastContainer, toast } from 'react-toastify';
import { getDownloadURL, getStorage, ref, uploadString } from 'firebase/storage';
import GoogleMaps from '../../Dashboard/Customer/MyTickets/GoogleMaps';

const EventCard = () => {
    const [event,setEvent] = useState({});
    const {id} = useParams();
    const [isLoading,setIsLoading] = useState(true);
    const navigate = useNavigate();
    const { userInfo, authenticated, logout,userDetails,getUserDetails } = useContext(UserContext);
    const [hours,setHours] = useState();
    const [minutes,setMinutes] = useState();
    const [selectedQuantity, setSelectedQuantity] = useState(1);


    const handleQuantityChange = (event) => {
        setSelectedQuantity(Number(event.target.value));
      };


    useEffect(()=> {
        const fetchEvent = async () => {
            try {
                const res = await axios.get(`https://event-finder12.onrender.com/events/getevent/${id}`); 
                setEvent(res.data);
                console.log(res.data)

                setHours(Math.floor(res.data.duration / 60));
                setMinutes(res.data.duration % 60);
                getUserDetails(userInfo.email);
                setIsLoading(false);

            } catch (error) {
                console.error("Error fetching event:", error);
            }
        };
        
        fetchEvent();
    },[id]);


    const handleQrUpload = async (qrCodeBase64,ticketID) => {
      const storage = getStorage();
      const file = Date.now() + '.png'
      const storageRef = ref(storage, `tickets/${userInfo.uid}/ticketQR/${file}`);
  
      try {
        
        await uploadString(storageRef, qrCodeBase64, 'data_url');
        const downloadURL = await getDownloadURL(storageRef);
  
        console.log(downloadURL)
  
        const response = await axios.put(`https://event-finder12.onrender.com/ticket/update-qr-url/${ticketID}`,{
          qrURL:downloadURL
        })
        return response.data;
  
      } catch (error) {
        console.error('Error uploading QR code:', error);
      }
    }
  


    const handleFreeTicket = async() => {
      console.log(userDetails)
      try {
        
        const ticketData = {
          id: event._id, 
          userId: userDetails._id,
          numberOfTickets: selectedQuantity 
        };
    
    
       
        const response = await axios.post('https://event-finder12.onrender.com/ticket/createticket', ticketData);
        
    
        const createdTicket = response.data;

        const updatedTicket = await handleQrUpload(createdTicket.qrCode,createdTicket._id)

        console.log(updatedTicket)
    
    
        console.log("Created Ticket:", createdTicket);

    
        try {
            const mailResponse = await axios.post('https://event-finder12.onrender.com/sendReceipt', {
                userEmail: userDetails.email,
                ticketCode: createdTicket.ticketCode, 
                qrCode: updatedTicket.qrCode,
                name:userDetails.displayName
            });
            console.log(mailResponse.data);
        } catch (error) {
            console.error("Failed to send receipt email:", error);
        }
    
        localStorage.setItem('ticketData', JSON.stringify(createdTicket));
        navigate(`/completion`);
      } catch (error) {
        console.error("Ticket creation failed:", error);
        toast.error("Ticket creation failed.");
      }
    }


    const handlePayment = () => {
        if (!authenticated || userInfo === null) {
                  navigate("/login");
                }else if(!isLoading && event.ticketPrice === 0){
                  handleFreeTicket();
                }else if(!isLoading){
                    navigate(`/payment/${id}/${selectedQuantity}`);
                }
    }


    const quantityOptions = [1, 2, 3, 4, 5, 6];

    console.log(selectedQuantity)



  return (
    <div className='event-card-class-container'>
        <div className='header-event-container'>
        <Header/>
        </div>
        
        {!isLoading ?<>
            <div className='event-detail-container'>
              <ToastContainer/>
              <div className='event-divs'>
                <div className='event-divs-row'>
                <FontAwesomeIcon className='grey' style={{marginRight:"0.6em"}} icon={faCalendarDays} />
              <p> {event.date.split("T")[0]}</p>
              <FontAwesomeIcon className='grey' style={{margin:"0px 0.6em"}} icon={faClock} />
               <p>{event.time} GMT</p>
                </div>
                <div className='event-divs-row'>
                <p>Duration: {hours}h {minutes}m</p>
                </div>
              </div>
        <div className="event-detail">
            <h1>{event.title}</h1>
            <h4>{event.description}</h4>
            <div className='event-card-location'>
            <FontAwesomeIcon className='grey' icon={faLocationDot} />
            <h5 style={{marginLeft:"0.5em"}}> {event.location.address}, {event.location.pincode} , {event.location.city} </h5>
           
            </div>
            {event.location.latitude && event.location.longitude ? <GoogleMaps lat={event.location.latitude} lng={event.location.longitude}/> : ""}
            <div className='event-card-location price'>
            <FontAwesomeIcon className='grey' icon={faMoneyBillWave} />
            <h5 style={{marginLeft:"0.5em"}}>{event.ticketPrice > 0 ? "£ " + event.ticketPrice : "Free"}</h5>
            </div>
           
            {event.numberOfTickets - event.ticketSold > 0 ?   <div className='sticker'> {event.numberOfTickets - event.ticketSold} Tickets Left Only</div>: <></>}
           
        </div>
        <div className="create-button-container ">
            {event.numberOfTickets - event.ticketSold === 0 ? (<><h2 style={{color:"red"}}>--Event Sold Out--</h2></>) : (<> <div onClick={handlePayment} className="purple-button buy-ticket">Buy Tickets</div>
            <div className='quantity-container'>
        <label>Select quantity: </label>
        <select value={selectedQuantity} onChange={handleQuantityChange}>
          {quantityOptions.map((quantity) => (
            <option key={quantity} value={quantity}>
              {quantity}
            </option>
          ))}
        </select>
      </div></>) }
           
        </div>
        </div>
        </> : <div>Loading</div>}
        
       

        <div className="footer"> 
            <div className="footer-info">
                <img src={logo}/>
                <h3>Discover upcoming events in your town: Your go-to online destination for staying updated with the latest happenings.</h3>
            </div>
            <hr className="line"/>
           <h4 className="copyright">Made with <FontAwesomeIcon style={{color:"red"}} icon={faHeart} /> by Sekh Mohammad Irfan </h4>
      </div>
    </div>
  )
}

export default EventCard